import axios from "axios";
import { TOKEN_KEY } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api/mechanic`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const money = (n) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(Number(n || 0));

export const fmtDate = (d) => {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch { return d; }
};

export const uploadReceipt = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload-receipt", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { file_id, url, name }
};

export const receiptHref = (url) => (url?.startsWith("http") ? url : `${BACKEND_URL}${url}`);

export default api;
